import React from 'react';
import { FormattedMessage } from 'react-intl';

import StyledNotAuthenticated from './StyledNotAuthenticated';
import { NotAuthenticatedItemProps } from './NotAuthenticatedItemProps';

const NotAuthenticated: React.FC<NotAuthenticatedItemProps> = ({ errorCode }) => {
  return (
    <StyledNotAuthenticated>
      <h1>
        <FormattedMessage id="notAuthenticated" values={{ errorCode: errorCode }} />
      </h1>
    </StyledNotAuthenticated>
  );
};

export default NotAuthenticated;
